import { Component, Vue, Prop } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import WithRender from './PreviewDocument.html';
import LoaderService from '@/Services/LoaderService';

import VuePdfApp from 'vue-pdf-app';
//import 'vue-pdf-app/dist/icons/main.css';

@WithRender
@Component({
    components: {
        VuePdfApp
    },
    diProvide: [
        LoaderService
    ]
})
export default class PreviewDocument extends Vue {
    @Inject(LoaderService) public loaderService!: LoaderService;

    public errorMessage = '';
    public docUrl = '';
    public isMobileView = true;
    public pdfConfig: object = {
        toolbar: false,
        sidebar: window.innerWidth < 500 ? false : true
    }
    public async mounted() {
        this.docUrl = process.env.BASE_URL + 'api/v1/PreviewDocument?docNo=' + this.$route.params.id;
        this.loaderService.ShowLoader();
         window.innerWidth > 500 ? this.isMobileView = true : this.isMobileView = false
    }

    public pdfPagesRendered(pdfApp:any) {
        let htmlElem = document.querySelector("html");
        if (htmlElem)
            htmlElem.setAttribute('dir', 'rtl');
        this.loaderService.HideLoader();
    }
    public async PrintReport() {
        
        let url =  process.env.BASE_URL + 'api/v1/PreviewDocument?docNo=' + this.$route.params.id;
        let req = await fetch(url)
        let res = await req.blob()
        let downloadUrl = window.URL.createObjectURL(res);
        let downloadLink = document.createElement('a');
        downloadLink.href = downloadUrl;
        downloadLink.download = `${this.$route.params.id}.pdf`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
    }
}